import React, { useState } from "react";
import { PageTitle } from "../PageTitle";
import OrderForm from "./order_form";
import { Redirect } from "react-router-dom";
import { Alert } from "react-bootstrap";

const OrderAdd = ({ location }) => {
    const [redirect, setRedirect] = useState(false);
    const [nextOrderData, setNextOrderData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const onSuccess = (_, addMore, submittedOrder) => {
        if (addMore) {
            setNextOrderData(submittedOrder);
        }
        setRedirect(true);
    };

    const onError = () => {
        setErrorMessage("Error adding order.");
    };

    if (redirect) {
        return nextOrderData ? 
        <Redirect to={{ pathname: "/admin-fulfillment/orders/add", state: { prefillData: nextOrderData } }} /> :
        <Redirect to={{ pathname: "/admin-fulfillment/orders", state: { successMessage: "Order added." } }} />;
    }

    return (
        <div className="animated fadeIn">
            <div className="row">
                <PageTitle title="Add Order" />
            </div>
            <div className="op-content-box">
                <div className="row">
                    <div className="col-sm-12">
                        {errorMessage && <Alert className="alert-danger" closeLabel="X">{errorMessage}</Alert>}

                        <OrderForm onSuccess={onSuccess} onError={onError} prefillData={location?.state?.prefillData} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderAdd;